export const DEFAULT_RESOURCE_NAME_PATTERN = /^[A-Za-z0-9_\-\s]{3,50}$/

export const validateResourceName = (name: string) => {
  return name.match(DEFAULT_RESOURCE_NAME_PATTERN)
}
